import classNames from 'classnames';

import FunnelCardRowSkeleton from 'containers/user/critical-elements-monitoring/components/funnel-card-row-skeleton';
import { FUNNEL_PANEL_CLASSES } from 'containers/user/critical-elements-monitoring/monitoring-constants';

const TotalFunnelSkeleton = () => (
  <div
    className={classNames(FUNNEL_PANEL_CLASSES, 'w-0 min-w-full')}
    data-testid="total-funnel-skeleton"
  >
    <FunnelCardRowSkeleton />
  </div>
);

export default TotalFunnelSkeleton;
